export default "__VITE_ASSET__d5QU98oE__"